// extracted by mini-css-extract-plugin
module.exports = {"building_carousel":"Building_building_carousel__qNn79","amenities_list":"Building_amenities_list__KImSK"};